import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const PROJECTS_QUERY = gql`
  query Projects($first: Int, $after: String, $status: ProjectStatus) {
    projects(first: $first, after: $after, status: $status) {
      edges {
        node {
          id
          name
          address
          status
          startDate
          endDate
          creator {
            fullName
          }
          members {
            id
            fullName
          }
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProject(
    $name: String!
    $address: String
    $startDate: ISO8601Date
    $endDate: ISO8601Date
    $paymentMethod: String!
    $hasConstructionTracking: Boolean
    $hasAdhocTracking: Boolean
    $internalNotes: String
  ) {
    createProject(
      name: $name
      address: $address
      startDate: $startDate
      endDate: $endDate
      paymentMethod: $paymentMethod
      hasConstructionTracking: $hasConstructionTracking
      hasAdhocTracking: $hasAdhocTracking
      internalNotes: $internalNotes
    ) {
      project {
        id
        name
      }
    }
  }
`;

interface CreateProjectInput {
  name: string;
  address?: string;
  startDate?: string;
  endDate?: string;
  paymentMethod: string;
  hasConstructionTracking?: boolean;
  hasAdhocTracking?: boolean;
  internalNotes?: string;
}

export function useCreateProject() {
  const [createProjectMutation, { loading, error }] = useMutation(CREATE_PROJECT_MUTATION);

  const createProject = async (input: CreateProjectInput) => {
    const { data } = await createProjectMutation({
      variables: input,
      refetchQueries: [{ query: PROJECTS_QUERY }],
    });
    return (data as any).createProject.project;
  };

  return { createProject, loading, error };
}